import React from 'react';
import SEO from '../components/SEO';
import { Link } from 'react-router-dom';
import '../styles/rooms.css';
import delux from "../assets/images/delux_1.jpg"
import twin from "../assets/images/twin_1.jpg"
import king from "../assets/images/king_2.jpg"
const Rooms = ({ language }) => {
  const roomsData = [
    {
      id: 'deluxe',
      title: { en: 'Deluxe Room', am: 'ዴሉክስ ክፍል' },
      description: {
        en: 'Spacious, elegantly furnished rooms with premium bedding, workspace, and city or garden views. Perfect for business travelers and those seeking extra comfort.',
        am: 'ሰፊ እና በውብ የታጠቁ ክፍሎች፣ ጥራታማ መኝታ እቃ፣ የስራ ቦታ እና የከተማ ወይም የአበባ ቦታ እይታ ጋር። ለንግድ ተጓዦች እና ተጨማሪ ምቾት ለሚፈልጉ ተስማሚ።'
      },
      features: {
        en: ['King-size bed', 'Work desk', 'City/Garden view', 'Premium bedding', 'Mini-bar', 'Free Wi-Fi'],
        am: ['ኪንግ ሳይዝ አልጋ', 'የስራ ጠረጴዛ', 'የከተማ/የአበባ ቦታ እይታ', 'ጥራታማ መኝታ እቃ', 'ሚኒ ባር', 'ነፃ ዋይ-ፋይ']
      },
      image: delux
    },
    {
      id: 'twin',
      title: { en: 'Standard Twin Room', am: 'መደበኛ ትዊን ክፍል' },
      description: {
        en: 'Two comfortable twin beds—ideal for friends or colleagues traveling together. Clean, modern amenities in a welcoming atmosphere.',
        am: 'ሁለት ምቹ ትዊን አልጋዎች፣ ከጓደኞች ወይም ከባልደረቦች ጋር ለመጓዝ ተስማሚ። ንፁህ፣ ዘመናዊ መሳሪያዎች በተቀባይ ሁኔታ።'
      },
      features: {
        en: ['Two twin beds', 'Shared workspace', 'Standard amenities', 'Air conditioning', 'Free Wi-Fi'],
        am: ['ሁለት ትዊን አልጋዎች', 'የጋራ የስራ ቦታ', 'መደበኛ መሳሪያዎች', 'የአየር ማቀዝቀዣ', 'ነፃ ዋይ-ፋይ']
      },
      image: twin
    },
    {
      id: 'king',
      title: { en: 'Standard King Room', am: 'መደበኛ ኪንግ ክፍል' },
      description: {
        en: 'A generous king bed with essential amenities for a restful and refreshing stay. Perfect for couples or solo travelers.',
        am: 'ለማረፍ እና ለማዳነቅ የሚረዱ አስፈላጊ መሳሪያዎች ጋር ሰፊ የኪንግ አልጋ። ለጥንዶች ወይም ለብቸኛ ተጓዦች ተስማሚ።'
      },
      features: {
        en: ['King-size bed', 'Standard amenities', 'Comfortable seating', 'Air conditioning', 'Free Wi-Fi'],
        am: ['ኪንግ ሳይዝ አልጋ', 'መደበኛ መሳሪያዎች', 'ምቹ መቀመጫ', 'የአየር ማቀዝቀዣ', 'ነፃ ዋይ-ፋይ']
      },
      image: king
    }
  ];

  return (
    <div className="rooms-page">
      <SEO
        title="Rooms & Suites"
        description="Explore our comfortable Deluxe, Twin, and King rooms at Blue Nest Hotel, designed for your perfect stay."
        url="/rooms"
      />
      {/* Hero Section */}
      <section className="rooms-hero">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 className="rooms-hero-title">
                {language === 'en' ? 'Our Rooms & Suites' : 'የእኛ ክፍሎች እና ስዊቶች'}
              </h1>
              <p className="rooms-hero-subtitle">
                {language === 'en'
                  ? 'Comfortable accommodations designed for your perfect stay at Blue Nest Hotel.'
                  : 'በብሉ ኔስት ሆቴል ለእርስዎ ፍጹም መኖሪያ የተዘጋጁ ምቹ መኖሪያዎች።'
                }
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Rooms Grid */}
      <section className="rooms-grid py-5">
        <div className="container">
          <div className="row">
            {roomsData.map((room, index) => (
              <div key={room.id} className="col-lg-4 col-md-6 mb-4">
                <div className="room-card">
                  <div className="room-image">
                    <img src={room.image} alt={room.title[language]} />
                  </div>
                  <div className="room-content">
                    <h3 className="room-title">{room.title[language]}</h3>
                    <p className="room-description">{room.description[language]}</p>

                    <div className="room-features">
                      <h5>{language === 'en' ? 'Features:' : 'ባህሪያት:'}</h5>
                      <ul>
                        {room.features[language].map((feature, idx) => (
                          <li key={idx}>{feature}</li>
                        ))}
                      </ul>
                    </div>

                    <Link to={`/rooms/${room.id}`} className="btn room-cta-btn">
                      {language === 'en' ? 'Learn More' : 'ተጨማሪ ይወቁ'}
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Info */}
      <section className="rooms-info py-5 bg-light">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 mx-auto text-center">
              <h2 className="mb-4">
                {language === 'en' ? 'Why Choose Blue Nest?' : 'ለምን ብሉ ኔስትን መምረጥ?'}
              </h2>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <div className="info-item">
                    <i className="fas fa-wifi info-icon"></i>
                    <h5>{language === 'en' ? 'Free Wi-Fi' : 'ነፃ ዋይ-ፋይ'}</h5>
                  </div>
                </div>
                <div className="col-md-4 mb-3">
                  <div className="info-item">
                    <i className="fas fa-concierge-bell info-icon"></i>
                    <h5>{language === 'en' ? '24/7 Service' : '24/7 አገልግሎት'}</h5>
                  </div>
                </div>
                <div className="col-md-4 mb-3">
                  <div className="info-item">
                    <i className="fas fa-utensils info-icon"></i>
                    <h5>{language === 'en' ? 'Restaurant & Bar' : 'ሬስቶራንት እና ባር'}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Rooms;
